import React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import { useFormik } from "formik";
import * as yup from "yup";
import { get } from "lodash";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditContainer() {
  const history = useHistory();
  let { id } = useParams();
  const data_params = { id: id };
  const classes = useStyles();
  const [cargoWeight, setCargoWeight] = useState("");

  const [ContainerStatus, setContainerStatus] = useState(1);
  const [ModId, setModId] = useState("");
  const [Submitting, setSubmitting] = useState(false);
  const EmpId = localStorage.getItem("EmpId");

  const validationSchema = yup.object({
    ContainerName: yup
      .string("Enter your ContainerName")
      .required("ContainerName is required"),
    ContainerNo: yup
      .string("Enter your ContainerNo")
      .required("ContainerNo is required"),
    type: yup.string("Enter your type").required("type is required"),

    Desc: yup
      .string("Enter your Description")
      .required("Description is required"),

    Size: yup.string("Enter your Size").required("Size is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      ContainerName: "",
      ContainerNo: "",
      type: "",
      Desc: "",
      Size: "",
      weight: ''
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const data = {
        no: values.ContainerNo,
        name: values.ContainerName,
        size: values.Size,
        desc: values.Desc,
        status: ContainerStatus,
        createId: EmpId,
        type: values.type,
        weight: values.weight
      };
      const dataUpdate = {
        id: id,
        no: values.ContainerNo,
        name: values.ContainerName,
        size: values.Size,
        desc: values.Desc,
        status: ContainerStatus,
        type: values.type,
        weight: values.weight,
        ModId,
      };
      setTimeout(() => {
        if (id) {
          api
            .post("api/container/update", dataUpdate)
            .then((respose) => {
              const MySwal = withReactContent(Swal);

              MySwal.fire({
                icon: "success",
                didOpen: () => {
                  MySwal.clickConfirm();
                },
              }).then(() => {
                return MySwal.fire(
                  "สำเร็จ!",
                  "แก้ไขประเภทตู้คอนเทนเนอร์ !",
                  "success"
                ).then((result) => {
                  if (result.isConfirmed) {
                    history.push("/Setting/Container");
                  }
                });
              });
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          api
            .post("api/container/create", data)
            .then((respose) => {
              const MySwal = withReactContent(Swal);

              MySwal.fire({
                icon: "success",
                didOpen: () => {
                  MySwal.clickConfirm();
                },
              }).then(() => {
                return MySwal.fire(
                  "สำเร็จ!",
                  "เพิ่มประเภทตู้คอนเทนเนอร์ !",
                  "success"
                ).then((result) => {
                  if (result.isConfirmed) {
                    history.push("/Setting/Container");
                  }
                });
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }

        setSubmitting(false);
      }, 400);
    },
  });

  const isError = (fieldName) => {
    return (
      get(formik.touched, fieldName, false) &&
      Boolean(get(formik.errors, fieldName, false))
    );
  };

  const getData = async () => {
    try {
      await api
        .post("api/container/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            [].concat(response.data).map((res) => {
              formik.setFieldValue("ContainerName", res.ContainerTypeName);
              formik.setFieldValue("ContainerNo", res.ContainerTypeNo);
              formik.setFieldValue("type", res.Type);
              formik.setFieldValue("Desc", res.ContainerDesc);
              formik.setFieldValue("Size", res.Size);
              formik.setFieldValue("weight", res.TareWeight);

              // res.Status.data.map((res) => {
              //   setContainerStatus(res);
              // });
              setContainerStatus(res.Status === true ? 1 : 0)
            });
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/Container");
                }
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };

  // const addData = async () => {
  //   const data = {
  //     no: ContainerNo,
  //     name: ContainerName,
  //     size: Size,
  //     desc: Desc,
  //     status: ContainerStatus,
  //     createId: EmpId,
  //     type,
  //   };
  //   console.log(data, "SAVE");

  //   api
  //     .post("api/container/create", data)
  //     .then((respose) => {
  //       const MySwal = withReactContent(Swal);

  //       MySwal.fire({
  //         icon: "success",
  //         didOpen: () => {
  //           MySwal.clickConfirm();
  //         },
  //       }).then(() => {
  //         return MySwal.fire(
  //           "สำเร็จ!",
  //           "เพิ่มประเภทตู้คอนเทนเนอร์ !",
  //           "success"
  //         ).then((result) => {
  //           if (result.isConfirmed) {
  //             history.push("/Setting/Container");
  //           }
  //         });
  //       });
  //       console.log(respose);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  //   // alert(JSON.stringify(data, null, 2));
  //   setSubmitting(false);
  // };

  // const editData = async () => {
  //   const data = {
  //     id: id,
  //     no: ContainerNo,
  //     name: ContainerName,
  //     size: Size,
  //     desc: Desc,
  //     status: ContainerStatus,
  //     type,
  //     ModId,
  //   };
  //   console.log(data, "SAVE");

  //   api
  //     .post("api/container/update", data)
  //     .then((respose) => {
  //       const MySwal = withReactContent(Swal);

  //       MySwal.fire({
  //         icon: "success",
  //         didOpen: () => {
  //           MySwal.clickConfirm();
  //         },
  //       }).then(() => {
  //         return MySwal.fire(
  //           "สำเร็จ!",
  //           "แก้ไขประเภทตู้คอนเทนเนอร์ !",
  //           "success"
  //         ).then((result) => {
  //           if (result.isConfirmed) {
  //             history.push("/Setting/Container");
  //           }
  //         });
  //       });
  //       console.log(respose);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  //   // alert(JSON.stringify(data, null, 2));
  //   setSubmitting(false);
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (id) {
  //     editData();
  //   } else {
  //     addData();
  //   }
  // };

  useEffect(() => {
    if (id) {
      getData();
    }
  }, []);

  return (
    <div>
      <Card
        variant="outlined"
        style={{ padding: "20px", margin: "25px", height: "86vh" }}
      >
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ประเภทตู้คอนเทนเนอร์
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Container
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / container
            </Typography>
          </Grid>
        </Grid>

        <form onSubmit={formik.handleSubmit} style={{ margin: "20px" }}>
          <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
            ประเภทตู้คอนเทนเนอร์
          </h6>
          <Grid container>
            <Grid item xs={6} sm={3} md={12}>
              <TextField
                name="ContainerName"
                label="Container name"
                variant="outlined"
                placeholder="Enter Container name"
                style={{
                  width: "50%",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                classes={{ root: !formik.values.ContainerName ? classes.customOutline : null }}
                required
                onChange={
                  (e) => formik.setFieldValue("ContainerName", e.target.value)
                  // setContainerName(e.target.value)
                }
                InputLabelProps={{ shrink: true }}
                value={formik.values.ContainerName}
                error={isError("ContainerName")}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={10} sx={{ display: "flex" }}>
              <TextField
                label="Container No."
                InputLabelProps={{ shrink: true }}
                placeholder="Enter Container No."
                name="ContainerNo"
                style={{
                  width: "40%",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                classes={{ root: !formik.values.ContainerNo ? classes.customOutline : null }}
                required
                onChange={(e) =>
                  formik.setFieldValue("ContainerNo", e.target.value)
                }
                value={formik.values.ContainerNo}
                error={isError("ContainerNo")}
              />

              <FormControl fullWidth>
                <InputLabel id="select_status-label">Status</InputLabel>
                <Select
                  name="select_status"
                  id="select_status"
                  value={ContainerStatus}
                  label="Status"
                  style={{
                    width: "43%",
                    marginLeft: "10px",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  onChange={(e) => setContainerStatus(e.target.value)}
                >
                  <MenuItem value={1}>Active</MenuItem>
                  <MenuItem value={0}>InActive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={3} md={12}>
              <TextField
                name="type"
                label="Type"
                variant="outlined"
                placeholder="Enter Type"
                style={{
                  width: "50%",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                classes={{ root: !formik.values.type ? classes.customOutline : null }}
                required
                InputLabelProps={{ shrink: true }}
                onChange={(e) => formik.setFieldValue("type", e.target.value)}
                value={formik.values.type}
                error={isError("type")}
              />
            </Grid>
            <Grid item xs={6} sm={3} md={12}>
              <TextField
                name="Desc"
                label="Description"
                variant="outlined"
                placeholder="Enter Description"
                style={{
                  width: "50%",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                classes={{ root: !formik.values.Desc ? classes.customOutline : null }}
                required
                InputLabelProps={{ shrink: true }}
                onChange={(e) => formik.setFieldValue("Desc", e.target.value)}
                value={formik.values.Desc}
                error={isError("Desc")}
              />
            </Grid>
            <Grid item xs={6} sm={3} md={12}>
              <TextField
                name="Size"
                label="Size"
                variant="outlined"
                placeholder="Enter Size"
                style={{
                  width: "50%",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                classes={{ root: !formik.values.Size ? classes.customOutline : null }}
                required
                InputLabelProps={{ shrink: true }}
                onChange={(e) => formik.setFieldValue("Size", e.target.value)}
                value={formik.values.Size}
                error={isError("Size")}
              />
            </Grid>
            <Grid item xs={6} sm={3} md={12}>
              <TextField
                label="Weight"
                name="weight"
                variant="outlined"
                // error={error}
                // helperText={error === true ? "กรุณากรอกข้อมูลให้ครบ" : ""}
                placeholder="Enter Weight"
                style={{
                  width: "50%",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                onChange={(e) => formik.setFieldValue("weight", e.target.value)}
                // onBlur={handleBlur}
                InputLabelProps={{ shrink: true }}
                value={formik.values.weight}
                classes={{ root: !formik.values.weight ? classes.customOutline : null }}
                required
              />
            </Grid>
          </Grid>
          <Button
            type="button"
            variant="outlined"
            style={{
              color: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            onClick={history.goBack}
          >
            back
          </Button>
          <Button
            type="submit"
            variant="contained"
            style={{
              background: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            disabled={Submitting}
          >
            {Submitting && <CircularProgress size={22} />}
            {!Submitting && "SAVE"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
